import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Constant,BaseComponent, DatePickerFormatter} from 'app/infrastructure/common/index';
import { OnlineOrderService } from 'app/infrastructure/services/transaction/op/outbound/order/index';
import { OnlineShippingNoticeService } from 'app/infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service';
import {SelectItem,LazyLoadEvent} from 'primeng/primeng';

import * as _ from 'lodash';

declare var jQuery: any;

@Component({
    selector: 'app-asn-list',
    templateUrl: './asn-list.html'
})
export class AsnListComponent extends BaseComponent implements OnInit {
    accounts:SelectItem[] = [];
    transCodes:SelectItem[] = [];
    statusCodes:SelectItem[] = [];

    selectedAsn:any;
    selectedAccount:any;
    selectedTransCode:any;
    selectedStatusCode:any;
    searchAsnNo:string;
    searchPoNo:string;
    searchSupplier:string;
    searchProduct:string;

    isLoading:boolean = false;
    isLoadingAccount:boolean = false;
    isLoadingTranscode:boolean = false;

    searchParams:any = {};
    asns:any;
    asnTotalRecord:number;
    tablePage:number;
    tablePageSize:number;

    constructor(private router: Router,
                private onlineShippingNoticeService : OnlineShippingNoticeService,
                private onlineOrderService: OnlineOrderService) {
        super();
    }

    ngOnInit(): void {
        this.preparePage();
        this.loadAccounts();
        this.loadTranscodes();
    }

    preparePage():void{
        //this.accounts.push({label:"All", value:null});
        this.transCodes.push({label:"All", value:null});

        this.statusCodes.push({label:"All", value:null});
        this.statusCodes.push({label:"New", value:"1"});
        this.statusCodes.push({label:"Draft", value:"D"});
        this.statusCodes.push({label:"Released", value:"2"});
        this.statusCodes.push({label:"Error", value:"E"});
    }

    loadAccounts(): void {
        let self = this;
        this.isLoadingAccount = true;

        var groupId = this.token.GroupId;
        this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
            .subscribe(
            data => {
                self.isLoadingAccount = false;
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        message.Result.forEach(obj => {
                            self.accounts.push({label:obj.OwnerName, value:obj});
                        });
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                }
            },
            error => {
                self.isLoadingTranscode = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            },            
            () => {                                
                let founded = _.find(self.accounts, function (obj) {
                    return obj.value.OwnerCode === self.token.DefaultOwnerCode;
                });

                if (founded)
                {
                    self.selectedAccount = founded.value;
                }

                self.loadAsnLazy(null);
            });
    }

    loadTranscodes(){
        let self = this;
        self.isLoadingTranscode = true;
        this.onlineShippingNoticeService.requestGetAsnTranscodes()
            .subscribe(data => {
                self.isLoadingTranscode = false;
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        message.Result.forEach(obj => {
                            self.transCodes.push({label:obj.TransCode, value:obj.TransCode});
                        });
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                }
            },
            error => {
                self.isLoadingTranscode = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            });
    }

    loadAsnLazy(event: LazyLoadEvent){
        let self = this;
        self.searchParams.DateFormat = self.token.DateFormatDescription
        self.searchParams.OwnerCode = self.selectedAccount != null ? self.selectedAccount.OwnerCode : null;
        self.searchParams.AsnNo = self.searchAsnNo;
        self.searchParams.PoNo = self.searchPoNo;
        self.searchParams.Transcode = self.selectedTransCode;
        self.searchParams.SupplierName = self.searchSupplier;
        self.searchParams.StatusCode = self.selectedStatusCode;
        self.searchParams.PageSize = event != null ? event.rows : self.tablePageSize;
        self.searchParams.Page = event != null ? (event.first / event.rows) + 1 : self.tablePage;        
        self.searchParams.ProductCode = self.searchProduct;
        self.searchParams.UserId = self.token.UserId;
        self.searchParams.GroupId = self.token.GroupId;
        if(event != null){
            self.tablePage = (event.first / event.rows) + 1;
            self.tablePageSize = event.rows;
        }

        console.log(JSON.stringify(self.searchParams))
        console.log(JSON.stringify(self.selectedAccount))

        this.onlineShippingNoticeService.requestGetAsns(self.searchParams)
          .subscribe(data => {
            let message = data;
            if (message && message.MessageType && message.MessageType.Value) {
              if (message.MessageType.Value == Constant.MessageType.success) {
                self.asns = message.Result;
                self.asnTotalRecord = message.TotalRecords;
                for(let item of self.asns){
                    switch(item.StatusCode){
                        case "D":
                            item.StatusCodeName = "Draft";
                            break;
                        case "1":
                            item.StatusCodeName = "New";
                            break;
                        case "2":
                            item.StatusCodeName = "Released";
                            break;
                        case "E":
                            item.StatusCodeName = "Error";
                            break;
                    }
                }
              }
              else {
                self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
              }
            }
            else {
              self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
            }
          },
            error => {
              self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
          });
      }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
    checkEditEnabled(statusCode: string): boolean {
        return statusCode ==  Constant.OnlineShippingNoticeStatus.draft;
    }
    gotoasn(data: any) {
        if(!this.isLoading)
            this.router.navigate(['pages/submit-asn'], { queryParams: { ownerCode: data.OwnerCode, asnNo: data.AsnNo } });
    }
    showDeleteConfirmation(asn: any) {
        if(!this.isLoading){
            this.selectedAsn = asn;
            jQuery('#PopupConfirmAsnList').modal("show");
        }
    }
    cancel(){
        this.selectedAsn = null;
        jQuery('#PopupConfirmAsnList').modal("hide");
    }
    delete(){
        jQuery('#PopupConfirmAsnList').modal("hide");
        if(this.selectedAsn != null){
            let self = this;
            this.isLoading = true;
            this.onlineShippingNoticeService.deleteShippingNotice(this.selectedAsn.Id)
                .subscribe(
                data => {
                    self.isLoading = false;
                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        if (message.MessageType.Value == Constant.MessageType.success)
                            self.loadAsnLazy(null);
                    }
                    else {
                        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                    }
                },
                error => {
                    self.isLoading = false;
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
    
                }
                );
        }
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
      }
    
    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }
    
    ngAfterViewInit() {
        var self = this;

        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
        }).on('change', (e) => {
            // alert(e.target.name);
            // alert(JSON.stringify(e.target ));
            self.searchParams[e.target.name] = jQuery(e.target).datepicker('getDate');
        });

    }
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/inbound/asn/asn-list/asn-list.component.ts